
import { defineComponent, onBeforeMount, ref } from 'vue';
import axios, { AxiosError } from 'axios';
import moment from 'moment';
import { getProgramDetails, updateProgram } from '@/utils/admin/program_services';
// eslint-disable-next-line
// import router from '@/router';
import { invokeGetUserRole } from '@/utils/admin/master_service';

export default defineComponent({
  name: 'ProgramDetails',

  // props: ['query'],
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const programId = ref(props.query.program_id);
    const renderReady = ref();
    const programDetails = ref();
    const taskAssignmentStrategy = ref();
    const reviewerAssignmentStrategy = ref();
    const errorMessage = ref();
    const proxyOHR = ref();
    const programAdmin = ref();
    // const programParticipants = ref([]);
    const showUpdate = ref(true);
    const loggedInUserRoles = ref();
    const programModuleName = ref();
    const skill = ref();
    const proficiency = ref();
    const startDate = ref();
    const endDate = ref();
    const showScreen = ref(true);
    const showSuccessMessage = ref(false);
    const resMessage = ref();
    const showErrorMessage = ref(false);
    const loggedInUser = ref();
    const yesNo = ref([
      { name: 'Yes', value: true },
      { name: 'No', value: false },
    ]);
    const isAcademy = ref([
      { name: 'True', value: true },
      { name: 'False', value: false },
    ]);
    const isPeerReviewNudgeEligible = ref([
      { name: 'Yes', value: 1 },
      { name: 'No', value: 0 },
    ]);
    const isTaskSubmissionNudgeEligible = ref([
      { name: 'Yes', value: 1 },
      { name: 'No', value: 0 },
    ]);
    const isProgramRestartable = ref([
      { name: 'Yes', value: 1 },
      { name: 'No', value: 0 },
    ]);
    const isMandatoryReviewsDisabled = ref(false);
    const defaultMatrix = `{
      "1": [2, 3, 4, 1, 1],
      "2": [2, 3, 4, 1, 1],
      "3": [2, 3, 4, 1, 1],
      "4": [-1, -1, -1, 2, 1],
      "5": [-1, -1, -1, 1, 2]
    }`;
    const checkEligibleMandatoryReviews = (strategy) => {
      console.log('change ran');
      if (strategy === 'Reviewer can be from a SME list') {
        isMandatoryReviewsDisabled.value = true;
        programDetails.value.mandatory_reviews = 0;
      } else {
        isMandatoryReviewsDisabled.value = false;
      }
    };
    const getProgram = async () => {
      try {
        renderReady.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await getProgramDetails(programId.value);
        programDetails.value = res.prog_detail;
        console.log(`programDetails.value.start_date before ${programDetails.value.start_date}`);
        console.log(`programDetails.value.end_date before ${programDetails.value.end_date}`);
        programDetails.value.start_date = moment(programDetails.value.start_date).format('YYYY-MM-DD');
        console.log(`programDetails.value.start_date after ${programDetails.value.start_date}`);
        programDetails.value.end_date = moment(programDetails.value.end_date).format('YYYY-MM-DD');
        console.log(`programDetails.value.end_date after ${programDetails.value.end_date}`);
        programDetails.value.wait_time_in_days_nudge_peer_review_not_completed = programDetails.value.wait_time_in_days_nudge_peer_review_not_completed ? programDetails.value.wait_time_in_days_nudge_peer_review_not_completed : 0;
        programDetails.value.task_seq_num = programDetails.value.task_seq_num ? programDetails.value.task_seq_num : 1;
        programDetails.value.proxy_completion_days = programDetails.value.proxy_completion_days ? programDetails.value.proxy_completion_days : 0;
        programDetails.value.is_task_submission_nudge_eligible = programDetails.value.is_task_submission_nudge_eligible ? programDetails.value.is_task_submission_nudge_eligible : 0;
        programDetails.value.termination_warning = programDetails.value.termination_warning ? programDetails.value.termination_warning : 365;
        programDetails.value.termination_after_warn_days = programDetails.value.termination_after_warn_days ? programDetails.value.termination_after_warn_days : 30;
        programDetails.value.band_priority_matrix = programDetails.value.band_priority_matrix ? programDetails.value.band_priority_matrix : defaultMatrix;
        programDetails.value.is_restartable = programDetails.value.is_restartable ? programDetails.value.is_restartable : 0;
        taskAssignmentStrategy.value = res.task_assignment_strategy;
        reviewerAssignmentStrategy.value = res.reviewer_assignment_strategy;
        programModuleName.value = res.program_module_name;
        skill.value = res.skill;
        proficiency.value = res.proficiency;
        console.log(`disable notifications ${programDetails.value.disable_notifications}`);
        // startDate.value = moment(res.prog_detail.start_date).format('DD-MM-YYYY');
        // endDate.value = moment(res.prog_detail.end_date).format('DD-MM-YYYY');
        programAdmin.value = programDetails.value.program_admin ? res.prog_detail.program_admin : [];
        console.log('program_admin', programAdmin.value);
        renderReady.value = true;
      } catch (error) {
        console.log(error);
      }
    };

    const updateRecord = async () => {
      try {
        console.log('Inside Update Program');
        // console.log(`moment(programDetails.value.end_date).diff(moment(programDetails.value.start_date), 'days') ${moment(programDetails.value.end_date).diff(moment(programDetails.value.start_date), 'days')}`);
        if (programDetails.value.pass_percentage < 1 || programDetails.value.pass_percentage > 100) {
          console.log('inside pass percentage if');
          errorMessage.value = 'Pass percentage Should be 1 to 100';
          window.scroll(0, 0);
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
        } else if (!programDetails.value.task_strategy) {
          console.log('inside Task Strategy if');
          errorMessage.value = 'Please Select Task Strategy';
          window.scroll(0, 0);
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
        } else if (!programDetails.value.reviewer_strategy) {
          window.scroll(0, 0);
          console.log('inside Reviewer Strategy if');
          errorMessage.value = 'Please Select Reviewer Strategy';
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
        } else if (parseInt(programDetails.value.task_seq_num, 10) === 0 || parseInt(programDetails.value.task_seq_num, 10) < 0) {
          window.scroll(0, 0);

          console.log('inside Sequence number should if');
          errorMessage.value = 'Task Sequence number should be greater than 0';
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
        } else if (programDetails.value.reviewer_strategy === 'Reviewer can be from a SME list' && programDetails.value.mandatory_reviews !== 0) {
          window.scroll(0, 0);
          errorMessage.value = "Mandatory Review should be 0 when strategy is 'Reviewer can be from a SME list'";
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
        } else if (programDetails.value.reviewer_strategy !== 'Reviewer can be from a SME list' && (programDetails.value.mandatory_reviews < 1 || programDetails.value.mandatory_reviews > 5)) {
          window.scroll(0, 0);
          errorMessage.value = 'Mandatory Review should be 1 to 5';
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
        } else if (programDetails.value.start_date && programDetails.value.end_date && moment(programDetails.value.end_date).diff(moment(programDetails.value.start_date), 'days') < 0) {
          window.scroll(0, 0);
          errorMessage.value = 'Start Date cannot be greater than End Date';
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
        } else {
          // console.log('inside else');
          // programDetails.value.linked_proxy_ohr = proxyOHR.value.split(',');
          // console.log('proxy OHR', programDetails.value.linked_proxy_ohr);
          renderReady.value = false;
          // programDetails.value.linked_proxy_ohr = proxyOHR.value ? proxyOHR.value : [];
          const updateRes = await updateProgram(programDetails.value);
          await getProgram();
          if (updateRes) {
            resMessage.value = updateRes;
            showSuccessMessage.value = true;
            setTimeout(() => {
              showSuccessMessage.value = false;
            }, 6000);
            renderReady.value = true;
            // router.push({ path: 'programAdministration' });
          }
        }
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log(err.response?.data);
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          console.log(`errorMessage.value ${errorMessage.value}`);
          showErrorMessage.value = true;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 6000);
        }
      }
    };
    onBeforeMount(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');
      await getProgram();
      loggedInUserRoles.value = role.user_roles;
      loggedInUser.value = role.user_key;
      if (loggedInUserRoles.value.length > 0) {
        if (loggedInUserRoles.value.includes('System Admin') || programAdmin.value.includes(loggedInUser.value)) {
          showUpdate.value = true;
          showScreen.value = true;
        } else {
          showUpdate.value = false;
          showScreen.value = false;
        }
        if (loggedInUserRoles.value.includes('System Admin View Access')) {
          showScreen.value = true;
          showUpdate.value = false;
        }
        // if (loggedInUserRoles.value.includes('System Admin') || loggedInUserRoles.value.includes('Proxy Admin')) {
        //   showScreen.value = true;
        // } else {
        //   showScreen.value = false;
        // }
      }
    });
    return {
      renderReady,
      programDetails,
      updateRecord,
      errorMessage,
      taskAssignmentStrategy,
      reviewerAssignmentStrategy,
      showUpdate,
      programModuleName,
      skill,
      proficiency,
      showScreen,
      startDate,
      endDate,
      showSuccessMessage,
      resMessage,
      showErrorMessage,
      loggedInUser,
      programAdmin,
      proxyOHR,
      yesNo,
      isAcademy,
      isPeerReviewNudgeEligible,
      isMandatoryReviewsDisabled,
      checkEligibleMandatoryReviews,
      isTaskSubmissionNudgeEligible,
      isProgramRestartable,
    };
  },
});
